import { toSchoolApiPayload } from '../../../utils/schoolFormMapper';
import { resolveVatPercent } from '../../../utils/vat';

// Pure builder for the AddNewIndividualSchoolPost body. Field-compatible with the
// pre-wizard submit — it adds Country, isTestAccount and the three-state characteristic
// booleans and drops an empty GroupType, but keeps every field the endpoint reads. Pure so
// the whole shape (school fields, products, subscription, ISO dates) is unit-testable.

const toIsoDate = (value) => (value ? new Date(value).toISOString().split('T')[0] : null);

export const buildSchoolPayload = (values, { matId } = {}) => {
  const term = parseInt(values.SubscriptionTerm, 10) || 1;
  return {
  ...toSchoolApiPayload(values),
  WondeeSchoolUrn: parseInt(values.Urn, 10) || 0,
  SchoolProducts: values.products || [],
  File: values.File || null,
  FileName: values.FileName || null,
  MatIdVal: matId || '',
  isTestAccount: values.isTestAccount || false,
  SubscriptionTerm: term,
  Year1Cost: values.Year1Cost || 0,
  // Never bill a year the term doesn't cover, even if the form state carries a stale value
  // from a longer term the operator selected first.
  Year2Cost: term >= 2 ? (values.Year2Cost || 0) : 0,
  Year3Cost: term >= 3 ? (values.Year3Cost || 0) : 0,
  VatPercentApplied: resolveVatPercent(values.VatPercentApplied),
  Discount: values.Discount || 0,
  PaymentCurrency: values.PaymentCurrency || 1,
  PaymentMode: values.PaymentMode || 1,
  IsMultiYear: term > 1,
  IsAutoRenewal: true,
  StartDate: toIsoDate(values.StartDate),
  EndDate: toIsoDate(values.EndDate),
  RenewalDate: toIsoDate(values.RenewalDate),
  };
};
